if (!customElements.get('noble-origins-buy')) {
  customElements.define(
    'noble-origins-buy',
    class extends HTMLElement {
      connectedCallback() {
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.priceEl = this.querySelector('[data-buy-price]');
        this.idInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.unitPrice = Number(this.submitButton?.dataset.unitPrice) || 0;

        this.querySelector('[data-qty-minus]')?.addEventListener('click', () => this.changeQty(-1));
        this.querySelector('[data-qty-plus]')?.addEventListener('click', () => this.changeQty(1));
        this.qtyInput?.addEventListener('change', () => this.setQty(this.qtyInput.value));
        document.addEventListener('noble-origins:variant-change', (event) => {
          if (event.detail?.variant) this.setVariant(event.detail.variant);
        });
        document.addEventListener('noble-origins:plan-change', (event) => {
          const section = this.closest('[data-section-id]');
          const source = event.target.closest?.('[data-section-id]');
          if (section && source && section !== source) return;
          if (typeof event.detail?.price !== 'number') return;
          this.unitPrice = event.detail.price;
          if (this.submitButton) this.submitButton.dataset.unitPrice = String(this.unitPrice);
          this.renderPrice();
        });
      }

      changeQty(delta) {
        this.setQty((Number(this.qtyInput?.value) || 1) + delta);
      }

      setQty(value) {
        const qty = Math.max(1, Number(value) || 1);
        if (this.qtyInput) this.qtyInput.value = String(qty);
        this.renderPrice();
      }

      setVariant(variant) {
        this.unitPrice = Number(variant.price) || 0;
        if (this.idInput) this.idInput.value = variant.id;
        if (this.submitButton) {
          this.submitButton.dataset.unitPrice = String(this.unitPrice);
          if (variant.available) {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.setAttribute('aria-disabled', 'true');
          }
        }
        this.renderPrice();
      }

      renderPrice() {
        if (!this.priceEl) return;
        const qty = Math.max(1, Number(this.qtyInput?.value) || 1);
        this.priceEl.textContent = this.formatMoney(this.unitPrice * qty);
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const amount = (cents / 100).toFixed(2);
        const noDecimals = String(Math.round(cents / 100));
        return format
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, amount);
      }
    }
  );
}
